import React from 'react'
import Layout from '../layout/layout'
import { Row, Col } from 'react-bootstrap'
import styles from './staticpages.module.css'
import { Link } from 'react-router-dom'

const TermsOfService: React.FC = () => {
  return (
    <Layout>
      <Row>
        <Col xl={8} className="mx-auto">
          <Row>
            <Col>
              <h1 className="pageTitle mb-4">GENERAL TERMS OF USE</h1>
            </Col>
          </Row>
          <Row>
            <Col className={styles.staticPage}>
              <h3>PREAMBLE </h3>
              <p>
                BIGMOCHI FINANCIAL PTE. LTD., (UEN 202012225H) (“<b>BigMochi</b>
                ”), a company incorporated in Singapore, developed and operates
                the BigMochi online e-commerce platform which is accessible at
                www.bigmochi.com (“<b>Platform</b>”). The Platform allows
                customers (“<b>Buyers</b>”) to purchase a range of Products and
                Courses from BigMochi and other sellers (“<b>Sellers</b>”).
              </p>
              <p>
                By using, visiting, accessing or registering with the Platform,
                you (referred to herein as “<b>you</b>” or “<b>your</b>”) agree
                to accept and be bound by the terms and conditions set out in
                these Terms of Use (“<b>TOU</b>”) and the policies referenced
                herein and/or available by hyperlink. This TOU will set out the
                terms governing Users and Buyers.
              </p>
              <p>
                YOU MAY NOT USE THE PLATFORM IF YOU DO NOT ACCEPT THIS TOU.
                PLEASE READ THIS TOU CAREFULLY AND IN ITS ENTIRETY. ANY USE OF
                THE BIGMOCHI PLATFORM IMPLIES YOUR ACCEPTANCE OF THESE TOU.
              </p>

              <h4>1. DEFINITIONS</h4>
              <p>1.1. The following definitions shall apply in these TOU:</p>
              <ul>
                <li>
                  "<b>Account</b>" means the Buyer account you opened or
                  registered with us to use the Platform.
                </li>
                <li>
                  "<b>Buyer</b>" designates a User who wishes to buy Products on
                  the Platform.
                </li>
                <li>
                  "<b>Content</b>" includes without limitation, information,
                  data, text, messages, writings, articles, responses, business
                  profiles, photographs, videos, audio clips, software, scripts,
                  graphics and interactive features generated, or other
                  materials created, submitted, provided or otherwise made
                  accessible on or through the Platform, excluding any personal
                  data.
                </li>
                <li>
                  "<b>Course(s)</b>" means the online course(s) that BigMochi or
                  Sellers offer for sale to Buyers which are listed and
                  available for purchase on the Platform.
                </li>
                <li>
                  "<b>Order</b>" means an order of a Product or a Course made
                  via the Platform in accordance with these TOU.
                </li>
                <li>
                  "<b>Platform</b>" refers to the online e-commerce platform
                  published and operated by BigMochi and accessible at
                  www.bigmochi.com and any and all web pages hosted on the
                  website.
                </li>
                <li>
                  "<b>Platform Services</b>" means (a) BigMochi acting as an
                  intermediary platform via the provision of the Platform,
                  including facilitating payment processes in relation to the
                  sale and purchase of the Products and Courses; (b) allowing
                  Buyers to search, browse and purchase Products and Courses
                  listed for sale by Sellers on the Platform; and (c) where
                  applicable, any services incidental to the provision of the
                  Platform.
                </li>
                <li>
                  "<b>Product</b>" means a product offered for sale by a Seller
                  to Buyer which is listed and available for purchase on the
                  Platform.
                </li>
                <li>
                  "<b>Sale Contract</b>" means each individual agreement
                  relating to an Order and entered into directly and only
                  between a Seller and a Buyer for a particular Product or
                  Course.
                </li>
                <li>
                  "<b>Sale Price</b>" means the selling price of the Product or
                  Course as set by the Seller.
                </li>
                <li>
                  "<b>Seller</b>" means any person or company or entity
                  registered on the Platform who offers for sale the Products or
                  Courses. BigMochi may also be a Seller on the Platform for
                  selected Products or Courses.
                </li>
                <li>
                  "<b>Seller Account</b>" means an account opened or set up by a
                  Seller to list Products and Courses on the Platform.
                </li>
                <li>
                  "<b>User</b>" means any person who accesses, uses, visits,
                  navigates, browses and/or registers with the Platform,
                  including Buyers and Sellers, but excluding BigMochi.
                </li>
              </ul>

              <h4>2. PURPOSE</h4>
              <p>
                2.1. The purpose of the Platform is to enable Users to benefit
                from its Platform, namely:{' '}
              </p>
              <ul>
                <li>
                  for Sellers: the offering of Products and Courses for sale on
                  the Platform; and
                </li>
                <li>
                  for Buyers: the possibility of browsing and purchasing of
                  Products and Courses on the Platform for delivery to locations
                  in Singapore, Indonesia and the Philippines.
                </li>
              </ul>
              <h5>2.2. Purpose of the Terms</h5>
              <p>
                These terms, concluded between BIGMOCHI and the USER
                (hereinafter referred to collectively as "the PARTIES"), are
                intended to set the contractual agreements relating to rights
                and obligations of the PARTIES whilst using the SERVICES.
              </p>

              <h4>3. ACCEPTANCE OF THE TERMS</h4>
              <p>
                3.1. Your use of the Platform and the Platform Services implies
                the acceptance of these TOU as a User and/or Buyer (as the case
                may be). These TOU are referenced at the bottom of each webpage
                of the Platform by means of a hyperlink and can thus be accessed
                at any time.
              </p>
              <p>
                3.2. Subject to Clause 3.3, you confirm that (i) you are more
                than 18 years old, (ii) you will only have registered an account
                with us in your real name, (iii) you have not been restricted by
                us in using the Platform or the Platform Services and (iv) you
                are otherwise fully able and competent to accept, abide and
                comply with these TOU.
              </p>
              <p>
                3.3. If you are below the age of 18, you must obtain, before
                using our Platform: (i) the consent of your parent(s) or legal
                guardian; (ii) their acceptance of these TOU herein; (iii) their
                guarantee in respect of your obligations under these TOU; and
                (iv) their guarantee in respect of your obligations in relation
                to any transactions on the Platform.
              </p>

              <h4>4. GENERAL</h4>
              <p>
                4.1. The Platform connects Sellers and Buyers in the sale and
                purchase of Products and Courses via the Platform. Products and
                Courses sold by Sellers are governed by individual Sale
                Contracts. Each Order accepted by a Seller shall constitute a
                separate Sale Contract, which specifies the agreement entered
                into directly and only between the Seller and the Buyer.
              </p>
              <p>
                4.2. You may choose to have Products or Courses listed based on
                the geographical region (e.g., Singapore, Indonesia, or the
                Philippines) of where the Product or Courses may be delivered.
              </p>
              <p>
                4.3. For Products or Courses for which BigMochi is not the
                Seller, BigMochi does not own the Products or Courses marketed
                via the Platform, has no control over them, and is not involved
                in the transaction between the Seller and you. The Sale Contract
                for each Product or Course is therefore exclusively and directly
                concluded between the Seller of the said Product or Course and
                you, and BigMochi is functioning as a mere technical
                intermediary providing the Platform for the transaction. The
                Sale Price and delivery terms are set by the Sellers without
                intervention of BigMochi, who is remunerated only on service
                charges and fees to the Seller. The Sale Price include all
                applicable prevailing taxes unless stated otherwise.
              </p>
              <p>
                4.4. The Sale Price shall be displayed in the local currency of
                the Buyer’s location, or otherwise as specified by us.
              </p>
              <p>
                4.5. For Products for which BigMochi is the Seller, such Sale
                Contract for each Product or Course shall be exclusively and
                directly concluded between the BigMochi and you. The Sale Price
                and delivery terms shall be set by BigMochi.
              </p>
              <p>
                4.6. Nothing in this TOU shall be considered to create a
                partnership, a relationship of principal and agent, or a
                relationship of employer and employee between BigMochi and a
                User.
              </p>

              <h4>5. CONDITIONS OF ACCESS & REGISTRATION</h4>
              <p>
                5.1. BigMochi (a) does not warrant that your use of the Platform
                will be uninterrupted or error-free or that the Platform will
                meet the your requirements; (b) shall not be responsible for any
                delays, delivery failures, or any other loss or damage resulting
                from the transfer of data over communications networks and
                facilities, including the internet; and (c) shall not be
                responsible for non-performance of the Platform caused by any
                use that is contrary to our instructions, or modification or
                alteration by any party other than us or our representatives,
                and will only provide support to correct such non-performance at
                our sole discretion.
              </p>
              <p>
                5.2. You acknowledge that the Platform may be subject to
                limitations, delays and other problems, owing to website, server
                or systems maintenance, or inherent in the use of such
                communications facilities and that BigMochi shall not be liable
                for any losses that may arise from such incidents.
              </p>
              <p>
                5.3. You warrant that you have the means and skills necessary
                for the use of the Platform and Platform Services. The equipment
                necessary to access and use the Platform is your sole
                responsibility, as well as any telecommunication costs incurred
                by such use.
              </p>
              <p>
                5.4. You can access the Platform and browse Products offered for
                sale without opening an Account on the Platform.
              </p>
              <p>
                5.5. However, where you intend to purchase any Product or Course
                on the Platform, you must first set up an Account with the
                Platform prior to making any purchase.
              </p>
              <p>
                5.6. When registering an Account to gain access to and use the
                Platform, you agree to provide BigMochi with true, accurate,
                current and complete information and details and other
                information that BigMochi may reasonably require to provide you
                with access to the Platform and the provision of Platform
                Services. You also agree to keep your contact information up to
                date.
              </p>
              <p>
                5.7. Your registration constitutes consent to BigMochi to use
                such data including any personal data which the User may provide
                in such registration for the purposes set out in
                BigMochi’s&nbsp;
                <Link to="/policies/privacy-policy">Privacy Policy</Link> and
                for all uses ancillary thereto for which the User’s consent may
                reasonably be implied.
              </p>
              <p>
                5.8. If you provide inaccurate, false, or erroneous information
                or fail to correct or update such information upon BigMochi’s
                request, BigMochi may immediately, without notice or
                compensation, suspend or terminate your Account.
              </p>
              <p>
                5.9. You are solely responsible for the management of your
                Account and password. You are solely responsible for restricting
                access to your computer(s) or device(s) used to access the
                Platform and maintaining the confidentiality and security of the
                Account, login details, passwords, and all activities that occur
                under the Account. You must notify BigMochi in writing
                immediately if you become aware of any unauthorised use of your
                Account or password or any suspected or actual security breaches
                or improper use of the Platform. You agree that the Account will
                be used by you only and will not be shared with or transferred
                to others.
              </p>
              <p>
                5.10. You are solely responsible for any activity on the
                Platform arising out of any failure to keep your password
                confidential and you may be held liable for any losses arising
                out of such a failure. BigMochi cannot and will not be liable
                for any loss or damage arising therefrom.
              </p>
              <p>
                5.11. For security purposes, including the investigation of
                whether any User is using the Platform for fraud, money
                laundering, insider trading or other unlawful activity, BigMochi
                has the right and sole discretion to immediately:
              </p>
              <ul>
                <li>Suspend or terminate an Account;</li>
                <li>
                  restrict your access to the entire Platform or parts thereof;
                </li>
                <li>suspend the provision of our Platform Services to you;</li>
                <li>
                  report such activity to the relevant law enforcement officials
                  and provide evidence in support for such officials to conduct
                  their investigations; and/or
                </li>
                <li>
                  take any action which we deem appropriate in the
                  circumstances.
                </li>
              </ul>
              <p>
                5.12. To the maximum extent permitted by law, BigMochi disclaims
                all responsibility and shall not be held responsible or held
                liable for any fraudulent use of a User’s Account. Unless
                otherwise shown, any access and action made from the Account of
                a User shall be presumed to have been made by the named User.
              </p>
              <p>
                5.13. You may at any time close your Account by sending a text
                to +65 8030 4988. Provided that all outstanding amounts owing to
                us have been paid to us, and all amounts and/or Products due to
                you have been paid or delivered to you, BigMochi will proceed
                within 14 working days to deactivate the Account and send you an
                email confirming such closure.
              </p>

              <h4>6. USER’S OBLIGATIONS</h4>
              <p>6.1. You warrant and agree that:</p>
              <ul>
                <li>
                  you will comply with any and all rules, regulations and/or
                  applicable laws in connection with the use of the Platform and
                  the Platform Services and through the submission of any
                  Content through the Platform;
                </li>
                <li>
                  you are responsible for all Content that you may submit or
                  otherwise transmit via the Platform;
                </li>
                <li>
                  You are the sole legal and beneficial owner of and own all
                  rights and interests in your Content and/or otherwise as for
                  the purposes set out in these TOU, and that such Content will
                  not infringe any third party rights and/or has the legal
                  rights to use the Content as required on the Platform;
                </li>
                <li>
                  Your Content will not contain any material which is
                  unauthorized, inaccurate, harmful, abusive, obscene,
                  libellous, defamatory, threatening or otherwise illegal;
                </li>
                <li>
                  You will not publish, distribute, send or upload any
                  inappropriate, obscene sexually explicit, racist, sexist,
                  defamatory, discriminatory, harassing, violent or offensive
                  Content, whether illegal or not;
                </li>
                <li>
                  Your Content will not contain any viruses, malware or harmful
                  or malicious code which could damage or adversely affect the
                  performance of the Platform or BigMochi’s provision of the
                  Platform Services, or any device accessing the Platform;
                </li>
                <li>
                  You undertake to keep BigMochi and our affiliates, officers,
                  agents, partners, and employees indemnified against any
                  losses, damages, costs, liabilities and expenses (including,
                  without limitation, legal expenses and any amounts paid by us
                  to a third party in settlement of a claim or dispute on the
                  advice of our legal advisers) incurred or suffered by us
                  arising out of the User’s breach of any of the warranties
                  and/or terms of this TOU or any alleged negligence, wilful
                  misconduct.
                </li>
              </ul>
              <p>6.2. You agree not to:</p>
              <ul>
                <li>
                  use the Platform or Platform Services other than as authorised
                  and in accordance with these TOU;
                </li>
                <li>
                  use the Platform for any other purpose save for obtaining the
                  Platform Services;
                </li>
                <li>
                  copy or use the Content on the Platform in connection with any
                  service deemed competitive by BigMochi;
                </li>
                <li>
                  copy, modify, translate or create derivative works of the
                  Content on the Platform and/or the Platform or any part
                  thereof;
                </li>
                <li>
                  send spam or other unwelcomed communications to others, or act
                  in an unlawful, defamatory, libellous, abusive, discriminatory
                  or otherwise objectionable manner as determined by us, through
                  the use of the Platform;
                </li>
                <li>
                  disparage the Platform, BigMochi or its employees, clients,
                  Products, business or any affiliates.
                </li>
                <li>
                  use any device, software, routine or use the Platform in any
                  way that interferes with any application, function, or use of
                  the Platform that is intended to damage, detrimentally
                  interfere with, surreptitiously intercept, or expropriate any
                  system, data, or communication, including but not limited to
                  our security mechanisms;
                </li>
                <li>
                  sell, sublicense, time-share, or otherwise share the Platform
                  with any third party;{' '}
                </li>
                <li>reformat, frame or mirror the Platform;</li>
                <li>
                  decompile, disassemble or reverse-engineer the underlying
                  software or application that is part of the Platform or
                  otherwise attempt to derive its source code;
                </li>
                <li>
                  use the Platform either directly or indirectly to support any
                  activity that is illegal, fraudulent, abusive and/or amoral
                  including but not limited to violating our Intellectual
                  Property Rights or that of others;
                </li>
                <li>
                  use the Platform in such a way or attempt to commercially
                  exploit any part of the Platform Services without our
                  permission, including without limitation modify any of the
                  Platform’s Content in any way, or copy, reproduce, publicly
                  display, distribute or otherwise use or communicate them for
                  any public or commercial purpose without our permission;
                </li>
                <li>
                  access and/or use the Platform for purposes of monitoring its
                  availability, performance or functionality, or for any other
                  benchmarking or competitive purposes; and
                </li>
                <li>authorize any third parties to do any of the above.</li>
              </ul>

              <h4>7. INTELLECTUAL PROPERTY </h4>
              <h5>Payment</h5>
              <p>
                7.1. A <b>Payment Processor</b> means a Third Party Service
                Provider appointed or engaged by BigMochi to process payments
                made through or on our Platform.
              </p>
              <p>
                7.2. Payment methods on the Platform include Singtel Dash, DBS
                PayNow, and DBS PayLah! and any other methods adopted by
                BigMochi.
              </p>
              <p>
                7.3. Where BigMochi is the Seller of the Product, you will pay
                the Sale Price directly to us via the Platform using the Payment
                Processor.
              </p>
              <p>
                7.4. Where BigMochi is not the Seller of the Product, we use the
                Payment Processor to bill and collect the Sale Price from you on
                the Sellers’ behalf via the Platform. In such Sale Contracts,
                you agree, understand, and acknowledge that BigMochi only acts
                as an independent third party contractor and an intermediary
                platform between you and the Seller. BigMochi’s role is limited
                to providing the Platform and the Platform Services, and acting
                as the payment collector (through our Payment Processor).
              </p>
              <p>
                7.5. You agree to be bound by terms as laid down from time to
                time by the Payment Processor; and consent and authorise us to
                delegate the authorisations and share information you provide to
                us with our Payment Processor to the extent required to provide
                the Platform and Platform Services to you.
              </p>
              <p>
                7.6. We may change a Payment Processor at any time and if so, we
                will inform you of the terms of the new Payment Processor.
              </p>
              <p>
                7.7. You may make payment of the Sale Price by an upfront
                payment in full or by instalments.
              </p>
              <p>
                7.8. <u>Upfront payment</u>. When you make an upfront payment of
                the Sale Price, delivery of the Product will be arranged, or
                provision of the Course, will be made upon payment.
              </p>
              <p>
                7.9. <u>Instalments</u>. When you choose to make payment of the
                Sale Price by instalments, delivery of the Product to a delivery
                address specified by you, or the provision of the Course, will
                only be arranged after full payment of the Sale Price.
              </p>
              <p>
                7.10. <u>Trusted Buyer Status</u>. Notwithstanding clause 7.9,
                when you have made timely payments of several instalments
                without any default, or upon BigMochi’s evaluation of your
                employment status, BigMochi may in its discretion grant you a
                “Trusted Buyer” status and allow for early delivery or provision
                of the Products or Courses purchased on the Platform to you
                after the first installation payment had been made. For the
                avoidance of doubt, you as a Trusted Buyers must complete full
                payment of the instalments even after delivery of the Product or
                provision of the Courses.
              </p>
              <p>
                7.11. <u>Default on Instalments</u>. Should a Trusted Buyer
                default on any instalment payment for any Product or Course,
                such Trusted Buyers would lose their “Trusted Buyer” status and
                they would be prohibited from selecting payment by instalments
                on the Platform. You will also be suspended from making any
                further purchases on the Platform until the default has been
                rectified. Where you are in the midst of making any purchase or
                are in the midst of receiving any Courses, your purchase will be
                put on hold and your access to the Courses shall be suspended
                until the default has been rectified.
              </p>
              <p>
                7.12. The exercise of BigMochi’s rights under Clause 7.11 is
                without prejudice to any other rights or remedies it has under
                this TOU or under any applicable law.{' '}
              </p>
              <h5>Refunds for Products</h5>
              <p>
                7.13. If you wish to seek a refund of a Product after receiving
                it, you (or your representative) shall return the Product to
                BigMochi’s offices, within seven (7) days of receipt of the
                Product, to one of the following listed address before the
                refund can be processed:
              </p>
              <ul>
                <li>
                  Singapore: 170 Upper Bukit Timah Road, #04-60, Singapore
                  588179.
                </li>
                <li>
                  The Philippines: 10, janet extension , san miguel, Tandang
                  Sora, Quezon City, Metro Manila, Metro Manila 1116.
                </li>
              </ul>
              <p>
                7.14. BigMochi’s employees will inspect the Product before
                deciding whether to process the refund. Upon receipt of the
                Product in good condition, BigMochi shall process the refund.
              </p>
              <p>
                7.15. In the event that BigMochi has received the returned
                Product after seven (7) days of your receipt of the Product, or
                where BigMochi has inspected and found the Product to not be in
                good condition, BigMochi will return the Product to the stated
                delivery address and the cost of the return shall be borne by
                you.
              </p>
              <p>
                7.16. Where you have made or have begun to make payment of the
                Sale Price of the Product by instalments under clause 7.9, you
                may still request for a refund of all payments made. However, in
                such scenarios, BigMochi reserves the right to charge an
                administrative fee of S$30, which shall be deducted from the
                amount to be refunded to you.
              </p>
              <h5>No Refund for Courses</h5>
              <p>
                7.17. When you have purchased a Course, no refunds will be
                provided for any reason whatsoever.
              </p>

              <h4>8. BIGMOCHI CREDITS AND PROMOTIONS</h4>
              <p>
                8.1. You will from time to time gain access to the promotions,
                discounts (such as discount codes), features (including but not
                limited to BigMochi Credits), or other benefits offered by us
                and/or third party merchants / partners as made available on the
                Platform (“<b>Promotions</b>”).
              </p>
              <p>
                8.2. For the avoidance of doubt, we reserve the right to change,
                remove or make unavailable part or whole promotions, discounts,
                features or other benefits.
              </p>
              <p>
                8.3. Please refer to the communications made available with such
                Promotion for the specific restrictions, including but not
                limited to whether the Promotion may be used to fully or
                partially set off the Sale Price, minimum purchase, number of
                redemptions per Buyer, and redemption dates.
              </p>
              <p>
                8.4. If there is a conflict between the general restrictions and
                the specific restrictions, the specific restrictions shall
                prevail.
              </p>
              <p>
                8.5. We reserve all rights to discontinue any Promotion offers
                and vary the general restrictions and/or specific restrictions
                at any time without prior notice to you.
              </p>
              <p>
                8.6. Use of the Promotions shall be subject to the following
                general restrictions:
              </p>
              <ul>
                <li>Only one Promotion may be used per transaction.</li>
                <li>
                  Promotions cannot be exchanged for cash value or credit.
                </li>
                <li>
                  Once redeemed for a transaction, a Promotion cannot be re-used
                  even if you cancel or change the transaction.
                </li>
                <li>
                  Any refunds for transactions made with Promotion shall be
                  subject to the Terms and shall only apply to the amount paid
                  after the application of the discount.
                </li>
                <li>
                  Promotions shall not be transferred, sold, used for multiple
                  bookings with the objective of re-selling such Products or
                  Courses, publicised on any third party platforms, or used for
                  any other improper purpose. If we determine that Promotions
                  have been used for an improper purpose, we may in our sole
                  discretion cancel all transactions made with the Promotions
                  and/or blacklist you from using other Promotions without prior
                  notice to you.
                </li>
                <li>
                  We may in our sole discretion offer replacement Promotions if
                  you are unable to redeem a Promotion due to a technical fault
                  on the Platform (provided that your attempted redemption is in
                  accordance with the Terms and the applicable specific
                  restrictions).
                </li>
              </ul>

              <h4>9. THIRD PARTY SERVICE PROVIDERS</h4>

              <p>
                9.1. <b>Third Party Service Provider</b> means any third party
                service provider, which includes but is not limited to a Payment
                Processor and website hosting providers, supplying services
                which are necessary in order for BigMochi to manage, host and
                operate the Platform and provide, and/or enhance the Platform
                Services, and/or any third party service provider which we
                engage.
              </p>
              <p>
                9.2. Your use of our Platform and the provision of the Platform
                Services by BigMochi may be provided by or may incorporate the
                services (“<b>Third Party Services</b>”) provided by Third Party
                Service Providers. The use of Third Party Services may require
                your agreement to certain additional terms and conditions
                provided by the applicable Third Party Service Providers, which
                will be made available to you if you use the Third Party
                Services.
              </p>
              <p>
                9.3. You hereby consent and authorise us to delegate the
                authorisations you provide to us to such Third Party Service
                Providers as we deem necessary to provide the Platform and
                Platform Services to you.
              </p>
              <p>
                9.4. You acknowledge that Third Party Service Providers are
                independent contractors as stipulated and we do not provide or
                exercise any control or oversight over the performance of Third
                Party Services. Users also acknowledge BigMochi shall not be
                responsible for any activity occurring within Third Party
                Services, even if logged in through or linked to our Platform.
                In the event the sale and purchase of Products on the Platform
                requires disclosure to and/or access of your Content, you agree
                that you will not hold us responsible for any breach on the part
                of the Third Party Service Provider, including but not limited
                to losses and/or damages suffered by you arising out the
                disclosure and/or access of your Content by the Third Party
                Service Providers.
              </p>
              <p>
                9.5. You also acknowledge and accept that a Third Party Service
                Provider may change, modify or discontinue, temporarily or
                permanently, suspend or discontinue any Third Party Services
                provided by them. We will use our best endeavours to provide
                notice to you within a reasonable period of time if and when we
                become aware of such change, modification, suspension and/or
                discontinuance of Third Party Services.
              </p>

              <h4>10. INTELLECTUAL PROPERTY</h4>
              <h5>Ownership of Intellectual Property Rights</h5>
              <p>
                10.1. You acknowledge the intellectual property rights of
                BigMochi on the Platform, its components and related contents
                and renounces any and all rights to challenge these rights in
                any form whatsoever.
              </p>
              <p>
                10.2. The trademarks, logos, slogans, graphics, photographs,
                animations, videos, software solutions and texts contained on
                the Platform are the exclusive intellectual property of BigMochi
                or the Sellers (insofar as the content is provided by the
                Sellers) and may not be reproduced, used or represented without
                prior authorization. Any User who fails to comply with these
                terms may be subject to prosecution or civil action.
              </p>
              <p>
                10.3. Any representation or reproduction, in whole or in part,
                of the Platform and its content, by whatever means, without
                prior authorization of BigMochi, or, as the case may be,
                Sellers, with regard to the content published by them, is
                prohibited and any such act shall constitute an infringement.
              </p>
              <p>10.4. In particular, BigMochi expressly prohibits:</p>
              <ul>
                <li>
                  The extraction, by permanent or temporary transfer of the
                  whole or a qualitatively or quantitatively substantial part of
                  the Platform, or any Content on the Platform, or the
                  Platform’s database, on another medium, by any means and in
                  any form;
                </li>
                <li>
                  The reproduction, by making available to the public the whole
                  or a qualitatively or quantitatively substantial part of the
                  Platform, or any Content on the Platform, or the Platform’s
                  database, by any means and in any form.
                </li>
              </ul>
              <p>
                10.5. Acceptance of these TOU is the acknowledgment by you of
                the intellectual property rights of BigMochi (and Sellers) and
                your commitment to respect them.
              </p>
              <h5>License of use of the Platform</h5>
              <p>
                10.6. BigMochi grants a personal, non-exclusive and
                non-transferable license to you authorizing you to use the
                Platform in accordance with these TOU.
              </p>
              <p>
                10.7. Any other exploitation of the Platform and Content on the
                Platform is excluded from the present license and shall not be
                carried out without the prior written authorization of BigMochi.
              </p>

              <h4>11. LIMITATION OF BIGMOCHI’S LIABILITY</h4>
              <p>
                11.1. BigMochi shall not be liable whether in contract, tort
                (including for negligence or breach of statutory duty),
                misrepresentation (whether innocent or negligent), restitution
                or otherwise for:
              </p>
              <ul>
                <li>
                  any loss of profits, sales, revenue, business, data, use,
                  goodwill or other intangible losses, or pure economic loss;
                </li>
                <li>
                  any indirect, incidental, exemplary, punitive or consequential
                  loss, costs, damages, charges or expenses;
                </li>
                <li>
                  any actions taken by us in good faith in accordance with the
                  information and instructions you have provided in connection
                  with the Platform and Platform Services;
                </li>
                <li>
                  any loss or damage caused by malware, distributed
                  denial-of-service attack, or other harmful material that may
                  infect your device, programs, data or other proprietary
                  material due to your use of the Platform or Platform Services;
                </li>
                <li>
                  any damages relating to your access to, use of, or inability
                  to access or use the Platform or Platform Services;
                </li>
                <li>
                  any damages relating to any conduct or Content of any third
                  party or another User of the Platform or Platform Services, or
                  any Third Party Service Provider, including without
                  limitation, defamatory, offensive, unlawful or illegal
                  conduct;
                </li>
                <li>
                  any Content, services or goods provided by a related party to
                  any Third Party Service Provider, including the quality of
                  such services or goods; and/or
                </li>
                <li>
                  any consequences arising in connection with a Force Majeure
                  Event.
                </li>
              </ul>
              <p>
                11.2. You are solely responsible for any damage, direct or
                indirect, material or immaterial caused by you to BigMochi or to
                third parties because while using the Platform or Platform
                Services.
              </p>
              <p>
                11.3 Notwithstanding any provision in these TOU, BigMochi’s
                total aggregate liability whether in contract, tort (including
                negligence or breach of statutory duty), misrepresentation
                (whether innocent or negligent), restitution or otherwise,
                including any professional and legal costs, arising in
                connection with the performance or contemplated performance of
                these TOU shall be{' '}
                <b>limited to the total Sale Price paid by you</b> to us for the
                Product or the Course where such dispute arises out of a
                transaction, or the amount of USD 50 for any other dispute. For
                the avoidance of doubt, the foregoing sets out our total
                financial liability to you in respect of any breach of these
                TOU, including but not limited to any personal data or data
                security breach.
              </p>
              <p>
                11.4. You further acknowledge and agree that the limitations of
                liability set out in these TOU reflect a reasonable and fair
                allocation of risk between you and BigMochi, and that these
                limitations are essential to BigMochi’s ability to make the
                Platform and Platform Services available to you on an
                economically feasible basis.
              </p>
              <h5>Hosting status </h5>
              <p>
                11.5. You acknowledge that BigMochi is a hosting provider. As
                such, BigMochi reserves the right to remove any Content,
                Product, or Course listing on the Platform that it considers to
                be manifestly illegal or inappropriate.
              </p>

              <h4>12. FORCE MAJEURE</h4>
              <p>
                12.1. BigMochi cannot be held liable, or be considered as having
                failed to perform its obligations under these TOU, for any delay
                or non-performance, when the cause of delay or non-performance
                results from events, circumstances or causes beyond its
                reasonable control (“<b>Force Majeure Event</b>”).
              </p>
              <p>
                12.2. <b>A Force Majeure Event</b> includes without limitation
                (a) acts of God, flood, drought, earthquake or other natural
                disaster; (b) epidemic or pandemic; (c) terrorist attack, civil
                war, civil commotion or riots, war, threat of or preparation for
                war, armed conflict, imposition of sanctions, embargo, or
                breaking off of diplomatic relations; (d) nuclear, chemical or
                biological contamination or sonic boom; (e) any law or any
                action taken by a government or public authority, including
                without limitation imposing an export or import restriction,
                quota or prohibition, or failing to grant a necessary licence or
                consent; (f) collapse of buildings, fire, explosion or accident;
                (g) any labour or trade dispute, strikes, industrial action or
                lockouts (other than in each case by the party seeking to rely
                on this clause); (h) non-performance by suppliers or
                subcontractors (other than by companies in the same group as the
                party seeking to rely on this clause); and (i) interruption or
                failure of utility or internet services.
              </p>
              <p>
                12.3. In such a situation, you shall not claim the payment of
                any compensation and shall not bring any action against
                BigMochi. In case of occurrence of one of the aforementioned
                events, BigMochi will endeavour to inform you as soon as
                possible.
              </p>

              <h4>13. PROTECTION OF PERSONAL DATA</h4>
              <p>
                13.1. BigMochi and you each agree that it shall comply with its
                legal and regulatory obligations relating to the protection of
                personal data, including its obligations under the Personal Data
                Protection Act 2012 (and all guidelines or codes of conduct
                issued by the Personal Data Protection Commission) and any other
                applicable personal data protection laws.
              </p>
              <p>
                13.2. As part of the operation of the Platform and provision of
                the Platform Services, BigMochi is likely to collect personal
                data of Users. The collection and use of such personal data are
                necessary for the management and continued operations of the
                Platform, including but not limited to the listing of Products
                for sale and for payment via the Platform. You may also choose
                to receive newsletters and other notifications from the
                Platform. Such personal data will be processed in accordance
                with the intended purposes of the collection.
              </p>
              <p>
                13.3. As such, please see BigMochi’s{' '}
                <Link to="/policies/privacy-policy">Privacy Policy</Link> which
                will give you more information about the treatments of personal
                data carried out by BigMochi. A User whose personal data are
                processed enjoys the rights to access, modify and/or withdraw
                consent to the processing of his/her personal data. These rights
                can be exercised by an e-mail request to the address&nbsp;
                <a href="mailto:store@bigmochi.com">store@bigmochi.com</a>.
              </p>

              <h4>14. GENERAL PROVISIONS</h4>
              <p>
                14.1. BigMochi reserves the right to update and modify these TOU
                at any time, which shall be effective when posted on the
                Platform or when you are reasonably notified by other means. If
                you do not wish to be bound by such change, you may discontinue
                using the Platform before the change becomes effective. Your
                continued use of the Platform after the change becomes
                effective, indicates your agreement to the change. We strongly
                advise you to review the terms of use published on the Platform
                on a regular basis to ensure you understand all terms and
                conditions governing use of the Platform and Platform Services.
              </p>
              <p>
                14.2. No failure or delay by a party to exercise any right or
                remedy provided under this TOU or by law shall constitute a
                waiver of that or any other right or remedy, nor shall it
                preclude or restrict the further exercise of that or any other
                right or remedy.
              </p>

              <h4>15. GOVERNING LAW</h4>
              <p>
                15.1. The use of the Platform and this TOU shall be governed by
                and construed in accordance with Singapore law.
              </p>

              <h4>16. DISPUTES</h4>
              <h5>Where BigMochi is the Seller</h5>
              <p>16.1. Where you have a dispute against BigMochi regarding:</p>
              <ul>
                <li>
                  a particular Product/Course where BigMochi is the Seller; or{' '}
                </li>
                <li>
                  a dispute arising out of or in connection with this TOU,
                  including any question regarding its existence, validity or
                  termination, or any claim or dispute in connection or relating
                  to the Platform or Platform Services, whether in contract or
                  tort or otherwise, you shall first contact BigMochi over
                  various channels available on the Platform via chat or email,
                  and our customer service team will contact you to resolve such
                  disputes.
                </li>
              </ul>
              <p>
                16.2. If such dispute cannot be settled or resolved by our
                customer service team and you, it shall be referred to and
                finally resolved by arbitration in Singapore administered by the
                Singapore International Arbitration Centre (SIAC) in accordance
                with the Arbitration Rules of the Singapore International
                Arbitration Centre (SIAC Rules) for the time being in force,
                which rules are deemed to be incorporated by reference in this
                clause. The Tribunal shall consist of 1 arbitrator. The language
                of the arbitration shall be in the English language. The seat of
                the arbitration shall be Singapore.
              </p>
              <h5>Where BigMochi is not the Seller</h5>
              <p>
                16.3. As stated in Clause 4.3 above, where BigMochi is not the
                Seller, BigMochi is merely acting as an intermediary platform.
                Where there is a dispute between you and the Seller, your sole
                recourse would be to contact the Seller directly. BigMochi may,
                but is not obliged to, facilitate discussions between you and
                Seller in good faith to resolve such disputes.
              </p>
              <p>
                16.4. By agreeing to use the Platform and to the terms of these
                TOU, where you have a claim or dispute regarding a particular
                Product/Course where BigMochi is not the Seller (and subject to
                the Seller agreeing to the same) which cannot be resolved
                pursuant to clause 15.3:
              </p>
              <ul>
                <li>
                  <u>S$30,000 or less</u>. Where the claim or amount in dispute
                  is S$30,000 or less, you agree to submit such claims or
                  disputes to the Small Claims Tribunal in Singapore (or such
                  equivalent tribunal in the Seller’s country of operations
                  outside of Singapore if the Seller is not based in Singapore).
                </li>
                <li>
                  <u>More than S$30,000</u>. Where the claim or amount in
                  dispute is more than S$30,000, you agree that any such claims
                  or disputes shall be referred to and finally resolved by
                  arbitration in Singapore administered by the Singapore
                  International Arbitration Centre (SIAC) in accordance with the
                  Arbitration Rules of the Singapore International Arbitration
                  Centre (SIAC Rules) for the time being in force, which rules
                  are deemed to be incorporated by reference in this clause. The
                  Tribunal shall consist of 1 arbitrator. The language of the
                  arbitration shall be in the English language. The seat of the
                  arbitration shall be Singapore.
                </li>
              </ul>
            </Col>
          </Row>
        </Col>
      </Row>
    </Layout>
  )
}

export default TermsOfService
